import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * Service for managing A/B Test Group Members (F-026).
 * Provides CRUD operations for member-to-group assignments.
 */
@Injectable({
    providedIn: 'root'
})
export class ABTestGroupMemberService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/abTestGroupMembers')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-users';
    }
}
